import brochurePDF from "../../assets/pdf/ONE _PAGE_IBC_DESCARGABLE.pdf";

// Iconos SVG como componentes
const GrowthIcon = () => (
  <svg
    className="w-12 h-12"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 48L24 32L36 44L56 16"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44 16H56V28"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="4" y="52" width="56" height="4" rx="2" fill="white" />
  </svg>
);

const RelationsIcon = () => (
  <svg
    className="w-12 h-12"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="32"
      cy="20"
      r="8"
      stroke="white"
      strokeWidth="2.5"
      fill="none"
    />
    <path
      d="M20 38c0-6 5-10 12-10s12 4 12 10"
      stroke="white"
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
    />
    <rect
      x="8"
      y="42"
      width="20"
      height="14"
      rx="3"
      stroke="white"
      strokeWidth="2"
      fill="none"
    />
    <rect
      x="36"
      y="42"
      width="20"
      height="14"
      rx="3"
      stroke="white"
      strokeWidth="2"
      fill="none"
    />
    <line x1="18" y1="49" x2="46" y2="49" stroke="white" strokeWidth="2" />
  </svg>
);

const CommerceIcon = () => (
  <svg
    className="w-12 h-12"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 56V36c0-2 1-3 3-3h6c2 0 3 1 3 3v20"
      stroke="white"
      strokeWidth="2.5"
      fill="none"
      strokeLinejoin="round"
    />
    <path d="M8 56h48" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    <path
      d="M22 44h-4M22 50h-4"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle
      cx="44"
      cy="28"
      r="10"
      stroke="white"
      strokeWidth="2.5"
      fill="none"
    />
    <text x="40" y="33" fill="white" fontSize="14" fontWeight="bold">
      $
    </text>
  </svg>
);

const DataIcon = () => (
  <svg
    className="w-12 h-12"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="12"
      y="8"
      width="40"
      height="48"
      rx="4"
      stroke="white"
      strokeWidth="2.5"
      fill="none"
    />
    <line
      x1="20"
      y1="20"
      x2="44"
      y2="20"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <line
      x1="20"
      y1="30"
      x2="44"
      y2="30"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="20"
      y1="38"
      x2="36"
      y2="38"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="20"
      y1="46"
      x2="40"
      y2="46"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// Datos de las tarjetas
const methodologyCards = [
  {
    id: 1,
    icon: GrowthIcon,
    title: "Fortalecimiento empresarial",
    description:
      "Capacitación y desarrollo para convertir tu empresa en un referente de tu industria",
  },
  {
    id: 2,
    icon: RelationsIcon,
    title: "Marketing de relaciones",
    description: "Estrategias clave para conectar con clientes",
  },
  {
    id: 3,
    icon: CommerceIcon,
    title: "Comercialización industrial",
    description:
      "Soluciones innovadoras para posicionar tu empresa en el sector",
  },
  {
    id: 4,
    icon: DataIcon,
    title: "Uso de datos",
    description:
      "Transforma la información en decisiones estratégicas con inteligencia de negocios",
  },
];

// Componente de tarjeta
const MethodologyCard = ({ icon: Icon, title, description }) => (
  <div className="bg-[#1e72b9] rounded-[20px] p-5 sm:p-6 flex items-start gap-4">
    <div className="bg-white/10 p-3 rounded-xl flex-shrink-0">
      <Icon />
    </div>
    <div className="text-white">
      <h3 className="font-bold text-lg sm:text-xl mb-2">{title}</h3>
      <p className="text-sm sm:text-base opacity-90">{description}</p>
    </div>
  </div>
);

function Methodology() {
  return (
    <>
      {/*-------------------- Inicio contenedor de "Metodología" --------------------*/}
      <section
        id="Methodology"
        className="mt-6 sm:mt-8 md:mt-10 py-10 sm:py-14 md:py-16 px-4 sm:px-6 md:px-8 bg-[#D6E4F0]"
      >
        <div className="max-w-5xl mx-auto">
          <p className="font-extrabold text-xl sm:text-xl md:text-2xl lg:text-2xl text-[#1e72b9] text-center mb-3 sm:mb-4">
            METODOLOGÍA
          </p>
          <p className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#29265b] text-center mb-3 sm:mb-4">
            Estrategia de Marketing Industrial
          </p>
          <p className="font-medium text-base sm:text-lg md:text-xl text-[#29265b] text-center mb-8 sm:mb-10 md:mb-12">
            Implementamos estrategias claves que
            <br className="hidden sm:block" />
            potencian la competitividad, visibilidad e innovación empresarial
          </p>

          {/* Grid de 4 tarjetas (2x2) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 md:gap-6 max-w-4xl mx-auto">
            {methodologyCards.map((card) => (
              <MethodologyCard
                key={card.id}
                icon={card.icon}
                title={card.title}
                description={card.description}
              />
            ))}
          </div>

          {/* Botón descarga PDF IBC */}
          <div className="flex justify-center w-full mt-8 sm:mt-10 md:mt-12">
            <a
              href={brochurePDF}
              download="ibc-brochure.pdf"
              className="bg-[#2a3180] cursor-pointer hover:bg-[#29265b] transition-colors text-white px-8 sm:px-12 py-3 rounded-[10px] flex items-center justify-center shadow-lg hover:shadow-xl"
            >
              <span className="text-base sm:text-lg font-semibold">
                Descargar información
              </span>
            </a>
          </div>
        </div>
      </section>
      {/*-------------------- Fin contenedor de "Metodología" --------------------*/}
    </>
  );
}

export default Methodology;
